import {useOperator} from "../context/OperatorContext";
import {Currency} from "types/Currency";

// Constants ----

const defaultLocale = 'en-GB';
const defaultCurrency: Currency = {
  code: 'GBP',
  symbol: '£',
  precision: 2,
}

// Types ----

export enum DiscountMode {PERCENT, AMOUNT}

// Custom hook ----

export default function useMoney() {
  const {settings} = useOperator();
  const operatorLocale = settings?.localisation.locale;

  function formattedMoney(amount: number, currency: Currency = defaultCurrency, locale?: string): string {
    const value = amount / Math.pow(10, currency.precision);

    const formatter = new Intl.NumberFormat(locale ?? operatorLocale ?? defaultLocale, {
      style: 'currency',
      currency: currency.code,
    });

    return formatter.format(value);
  }

  return { formattedMoney };
}